import { ColumnType } from 'antd/es/table/interface';
import { useMemo } from 'react';
import { useTranslation } from 'translations/hooks';

import { ActionsExpandedColumn } from 'business/quality-control/pages/segment-history/components/actions-expanded-column';
import { StatusTag } from 'business/quality-control/pages/segment-history/components/status-tag';
import { formatDateWithMiddleDot } from 'technical/format/date';

import { SegmentHistory } from './data/types';

const SPECIFIC_HISTORY_LABEL = ['label.import', 'label.manual'];

export const useSegmentHistoryExpandedColumns = (
  isUserManager: boolean,
  refetchData: () => void,
) => {
  const { t } = useTranslation();
  return useMemo(
    () =>
      [
        {
          title: t('qualityControl.segmentHistory.expandedColumns.history'),
          width: 150,
          dataIndex: 'label',
          key: 'label',
          render: (label: string) =>
            SPECIFIC_HISTORY_LABEL.includes(label)
              ? t(`qualityControl.segmentHistory.${label}`)
              : label,
        },
        {
          title: t('qualityControl.segmentHistory.expandedColumns.date'),
          width: 180,
          dataIndex: 'createdAt',
          key: 'createdAt',
          render: (text: string) => (
            <span>{formatDateWithMiddleDot(text)}</span>
          ),
        },
        {
          title: t('qualityControl.segmentHistory.expandedColumns.status'),
          width: 120,
          dataIndex: 'status',
          key: 'status',
          render: (status: string) => <StatusTag status={status} />,
        },
        {
          key: 'actions',
          render: (_, record) => {
            return (
              <ActionsExpandedColumn
                record={record as SegmentHistory}
                isUserManager={isUserManager}
                refetchData={refetchData}
              />
            );
          },
        },
      ] satisfies ColumnType[],
    [t, isUserManager, refetchData],
  );
};
